import { AxiosRequestConfig } from 'axios';
import API from 'services/api.js';
import { URL_GET_METHANE_LIST, URL_GET_METHANE_DATA } from 'services/urls.js';

export type MethaneRow = {
	date: string;
	records: number;
};

export type MethaneListResponse = {
	weigherId: string;
	timezone: string;
	methane: MethaneRow[];
};

export const actionGetMethaneList = async (
	sessionId: number
): Promise<MethaneListResponse[]> => {
	const config = {
		params: {
			sessionId,
		},
	};
	return (await API.get<MethaneListResponse[]>(URL_GET_METHANE_LIST, config))
		.data;
};

export const actionDownloadMethaneData = (sessionId: number, date: string) => {
	const params: AxiosRequestConfig = {
		params: {
			sessionId,
			date,
		},
		responseType: 'blob',
		timeout: 60000,
		headers: {
			'x-opw-format': 'csv',
		},
	};
	return API.get(URL_GET_METHANE_DATA, params);
};
